import React, { useEffect, useState } from "react";
import { getMerchantDetails, updateMerchantDetails } from "../../../api-handle/merchantApi";
import UserInfo from "./Components/UserInfo";
import MerchantInfo from "./Components/MerchantInfo";
import ImageGallery from "./Components/ImageGallery";
import DocumentPreview from "./Components/DocumentPreview";
import styles from "./MerchantDetailPage.module.scss";
import { Breadcrumbs } from "../../../AbstractElements";
import BankDetails from "./Components/BankDetails";
import Loader from "../../../CommonElements/Loader/loader";

const MerchantDetailPage = () => {
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [updatedData, setUpdatedData] = useState(null);
    const [activeTab, setActiveTab] = useState("UserInfo");
    const [refetch, setRefetch] = useState(false)

    useEffect(() => {
        const getMerchant = async () => {
            try {
                setLoading(true);
                const response = await getMerchantDetails();
                setData(response);
                setUpdatedData(response);
                setLoading(false);
            } catch (error) {
                setErrorMessage(error?.message || "Something went wrong.");
                console.error("Error fetching merchant details:", error);
            }
        };

        getMerchant();
    }, [refetch]);

    const handleUpdate = async () => {
        try {
            setLoading(true);
            const response = await updateMerchantDetails(updatedData);
            setData(response);
            setLoading(false);
        } catch (error) {
            setErrorMessage(error?.message || "Update failed.");
            console.error("Error updating merchant details:", error);
        }
    };

    return (
        <div className={styles.merchantDetailContainer}>
            <Breadcrumbs
                mainTitle="Merchant Profile"
                parent="Merchants"
                title="Merchant Profile"
            />

            <div className={styles.contentWrapper} style={{ display: "flex", flexWrap: "wrap", minHeight: "100vh" }}>
                {/* Sidebar Navigation with Bootstrap */}
                <aside
                    style={{
                        width: "250px",
                        backgroundColor: "#33bdbf",
                        padding: "20px",
                        height: "100vh", // Keep sidebar at 100vh
                        borderRadius: "8px",
                        marginRight: "20px",
                        overflow: "auto",
                    }}
                    className="d-none d-md-block"
                >
                    <ul
                        style={{
                            listStyle: "none",
                            padding: 0,
                            margin: 0,
                        }}
                    >
                        {[
                            { key: "UserInfo", label: "User Info" },
                            { key: "ImageGallery", label: "Media Gallery" },
                            { key: "MerchantInfo", label: "Merchant Info" },
                            { key: "DocumentPreview", label: "Documents" },
                            { key: "BankDetails", label: "Bank Details" },
                        ].map((item) => (
                            <li
                                key={item.key}
                                style={{
                                    padding: "10px 15px",
                                    backgroundColor: activeTab === item.key ? "rgba(255, 255, 255, 0.2)" : "transparent",
                                    color: "#fff",
                                    cursor: "pointer",
                                    borderRadius: "4px",
                                    marginBottom: "5px",
                                    fontWeight: activeTab === item.key ? "bold" : "normal",
                                    transition: "background-color 0.3s",
                                }}
                                onClick={() => setActiveTab(item.key)}
                                onMouseOver={(e) =>
                                    (e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.3)")
                                }
                                onMouseOut={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                    activeTab === item.key ? "rgba(255, 255, 255, 0.2)" : "transparent")
                                }
                            >
                                {item.label}
                            </li>
                        ))}
                    </ul>
                </aside>

                {/* Mobile Dropdown for Small Screens */}
                <div className="d-md-none mb-3 w-100">
                    <select
                        className="form-select"
                        value={activeTab}
                        onChange={(e) => setActiveTab(e.target.value)}
                        style={{ backgroundColor: "#33bdbf", color: "#fff" }}
                    >
                        <option value="UserInfo">User Info</option>
                        <option value="ImageGallery">Media Gallery</option>
                        <option value="MerchantInfo">Merchant Info</option>
                        <option value="DocumentPreview">Documents</option>
                        <option value="BankDetails">Bank Details</option>
                    </select>
                </div>

                {/* Main Content with Height Constraint */}
                <div
                    className={styles.mainContent}
                    style={{
                        flex: 1,
                        maxHeight: "100vh", // Constrain height to viewport
                        overflowY: "auto", // Enable vertical scrolling
                        padding: "20px",
                    }}
                >
                    {loading && <p className={styles.loadingText}><Loader /></p>}
                    {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}

                    {data && (
                        <>
                            {activeTab === "UserInfo" && (
                                <UserInfo
                                    userData={data.user}
                                    setUserData={(updatedUser) =>
                                        setUpdatedData((prev) => ({ ...prev, user: updatedUser }))
                                    }
                                    handleUpdate={handleUpdate}
                                    refetch={refetch}
                                    setRefetch={setRefetch}
                                />
                            )}
                            {activeTab === "ImageGallery" && <ImageGallery merchantData={data?.merchant} setRefetch={setRefetch} />}
                            {activeTab === "MerchantInfo" && <MerchantInfo merchantData={data.merchant} setRefetch={setRefetch} />}
                            {activeTab === "DocumentPreview" && (
                                <DocumentPreview merchant={data.merchant} setRefetch={setRefetch} />
                            )}
                            {activeTab === "BankDetails" && <BankDetails />}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MerchantDetailPage;